<div class="card-header">{{title}}</div>
<div class="card-body">
  <ng-content select="[content]"></ng-content>
</div>
